import { Status404 } from "../components/Box/Status"

const Page404 = () => {
  return <Status404 />
}

export default Page404